var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _g, _path2, _g2, _path3, _g3, _circle, _circle2, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmsNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 95,
    viewBox: "0 0 118 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_937_14025)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.666 17.6641C19.7605 17.6641 19.8397 17.6321 19.9037 17.5681C19.9677 17.5041 19.9996 17.425 19.9993 17.3307C19.9993 17.2363 19.9673 17.1572 19.9033 17.0934C19.8393 17.0296 19.7602 16.9976 19.666 16.9974C19.5716 16.9974 19.4925 17.0294 19.4287 17.0934C19.3649 17.1574 19.3329 17.2365 19.3327 17.3307C19.3327 17.4252 19.3647 17.5044 19.4287 17.5684C19.4927 17.6324 19.5718 17.6643 19.666 17.6641ZM20.9993 17.6641C21.0938 17.6641 21.173 17.6321 21.237 17.5681C21.301 17.5041 21.3329 17.425 21.3327 17.3307C21.3327 17.2363 21.3007 17.1572 21.2367 17.0934C21.1727 17.0296 21.0936 16.9976 20.9993 16.9974C20.9049 16.9974 20.8258 17.0294 20.762 17.0934C20.6982 17.1574 20.6662 17.2365 20.666 17.3307C20.666 17.4252 20.698 17.5044 20.762 17.5684C20.826 17.6324 20.9051 17.6643 20.9993 17.6641ZM22.3327 17.6641C22.4271 17.6641 22.5063 17.6321 22.5703 17.5681C22.6343 17.5041 22.6662 17.425 22.666 17.3307C22.666 17.2363 22.634 17.1572 22.57 17.0934C22.506 17.0296 22.4269 16.9976 22.3327 16.9974C22.2382 16.9974 22.1591 17.0294 22.0953 17.0934C22.0316 17.1574 21.9996 17.2365 21.9993 17.3307C21.9993 17.4252 22.0313 17.5044 22.0953 17.5684C22.1593 17.6324 22.2385 17.6643 22.3327 17.6641ZM18.9993 19.9974L18.2327 20.7641C18.1271 20.8696 18.0062 20.8933 17.87 20.8351C17.7338 20.7768 17.6658 20.6726 17.666 20.5224V15.3307C17.666 15.1474 17.7313 14.9905 17.862 14.8601C17.9927 14.7296 18.1496 14.6643 18.3327 14.6641H23.666C23.8493 14.6641 24.0064 14.7294 24.137 14.8601C24.2677 14.9907 24.3329 15.1476 24.3327 15.3307V19.3307C24.3327 19.5141 24.2675 19.6711 24.137 19.8017C24.0066 19.9324 23.8496 19.9976 23.666 19.9974H18.9993ZM18.716 19.3307H23.666V15.3307H18.3327V19.7057L18.716 19.3307Z",
    fill: "#FFF4F0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_937_14025)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 66,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 72,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 76,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_937_14025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 56.375L59.375 56.375L59.375 55L58.625 55ZM58.625 57.2917L58.625 60.0417L59.375 60.0417L59.375 57.2917L58.625 57.2917ZM58.625 60.9583L58.625 63.7083L59.375 63.7083L59.375 60.9583L58.625 60.9583ZM58.625 64.625L58.625 66L59.375 66L59.375 64.625L58.625 64.625Z",
    fill: "#7DB9FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 57.2917L59.375 57.2917L59.375 55L58.625 55ZM58.625 58.2083L58.625 62.7917L59.375 62.7917L59.375 58.2083L58.625 58.2083ZM58.625 63.7083L58.625 66L59.375 66L59.375 63.7083L58.625 63.7083Z",
    fill: "#42CFEF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_937_14025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "5 1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_937_14025)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#42CFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.75,
    cy: 46.75,
    r: 6.75,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 46.625C57.6063 46.625 57.6954 46.589 57.7674 46.517C57.8394 46.445 57.8753 46.356 57.875 46.25C57.875 46.1437 57.839 46.0547 57.767 45.983C57.695 45.9113 57.606 45.8753 57.5 45.875C57.3938 45.875 57.3048 45.911 57.233 45.983C57.1613 46.055 57.1253 46.144 57.125 46.25C57.125 46.3563 57.161 46.4454 57.233 46.5174C57.305 46.5894 57.394 46.6253 57.5 46.625ZM59 46.625C59.1063 46.625 59.1954 46.589 59.2674 46.517C59.3394 46.445 59.3753 46.356 59.375 46.25C59.375 46.1437 59.339 46.0547 59.267 45.983C59.195 45.9113 59.106 45.8753 59 45.875C58.8938 45.875 58.8048 45.911 58.733 45.983C58.6613 46.055 58.6253 46.144 58.625 46.25C58.625 46.3563 58.661 46.4454 58.733 46.5174C58.805 46.5894 58.894 46.6253 59 46.625ZM60.5 46.625C60.6063 46.625 60.6954 46.589 60.7674 46.517C60.8394 46.445 60.8753 46.356 60.875 46.25C60.875 46.1437 60.839 46.0547 60.767 45.983C60.695 45.9113 60.606 45.8753 60.5 45.875C60.3938 45.875 60.3048 45.911 60.233 45.983C60.1613 46.055 60.1253 46.144 60.125 46.25C60.125 46.3563 60.161 46.4454 60.233 46.5174C60.305 46.5894 60.394 46.6253 60.5 46.625ZM56.75 49.25L55.8875 50.1125C55.7688 50.2312 55.6328 50.2579 55.4795 50.1924C55.3263 50.1269 55.2498 50.0096 55.25 49.8406V44C55.25 43.7937 55.3235 43.6173 55.4705 43.4705C55.6175 43.3238 55.794 43.2502 56 43.25H62C62.2063 43.25 62.3829 43.3235 62.5299 43.4705C62.6769 43.6175 62.7503 43.794 62.75 44V48.5C62.75 48.7063 62.6766 48.8829 62.5299 49.0299C62.3831 49.1769 62.2065 49.2502 62 49.25H56.75Z",
    fill: "#394353"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_937_14025",
    x: 0,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_14025"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_14025"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_14025",
    result: "effect2_dropShadow_937_14025"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_14025",
    result: "effect3_dropShadow_937_14025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_14025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_937_14025",
    x: 0,
    y: 60,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_14025"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_14025"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_14025",
    result: "effect2_dropShadow_937_14025"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_14025",
    result: "effect3_dropShadow_937_14025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_14025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_937_14025",
    x: 48.2383,
    y: 47,
    width: 21.5234,
    height: 27.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_14025"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_937_14025",
    x: 50.625,
    y: 22,
    width: 16.75,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_14025"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_937_14025",
    x: 47.126,
    y: 35.125,
    width: 23.25,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_937_14025"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsNode);
export default __webpack_public_path__ + "static/media/smsNode.6f0ee6d47ebf73eb56a20cdc69409a01.svg";
export { ForwardRef as ReactComponent };